import { render, staticRenderFns } from "./dayrecords.vue?vue&type=template&id=77be51d5"
import script from "./dayrecords.vue?vue&type=script&lang=js"
export * from "./dayrecords.vue?vue&type=script&lang=js"
import style0 from "./dayrecords.vue?vue&type=style&index=0&id=77be51d5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports